// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"8c87c124","441":"ee9b2595","854":"62403861","980":"3d6f8401"}[chunkId] + ".chunk.css";
};